import React from 'react';
import { hooks } from 'mage-i18n';
import { Typography } from '@klarna/bubble-ui';
const DefaultBotMessage = ({ translationKey }) => {
    const t = hooks.useTranslator();
    return (React.createElement(Typography, { textToken: 'text-style/text/super-paragraphs/body/regular' }, t(translationKey)));
};
export default DefaultBotMessage;
